module.exports = __webpack_public_path__ + "media/stylesheets/images/main/openWaiting/openWaiting_pc_economy-3234c6abc6024c182d660cd9571f9b6d.png";